export enum VerifyMFAOTPEnums {
    IMAGE_ALT = 'Carbon one',
    HEADING = 'Verify your Email',
    SUBHEADING = 'We have sent you a verification code via email',
    HELPER_TEXT = 'Didn\'t receive the OTP?',
    HELPER_TEXT_SPAN = 'Re-send OTP',
    BUTTON_LABEL_SUBMIT = 'Verify',
    BUTTON_LABEL_BACK = 'Back',
}

